import { ConstraintFacilityConstrainedScheduleBase } from './base/constraint-facility-constrained-schedule-base';

export class ConstraintFacilityConstrainedSchedule extends ConstraintFacilityConstrainedScheduleBase { }